import React from 'react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import classnames from 'classnames';

import { IconButton } from 'ui-components/components/button/icon-button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.less';
import { useShouldShowTrialInfoBanner, useShouldShowTrialWarningBanner } from '../../../../hooks/header-notification-banner-hooks';
import { OnboardingStepsComponents } from '../../constants';
import { useHomePageOnboardContext } from '../../home-page-onboard-context';
import { messages } from '../onboard-section/messages';
import { OnboardingCompleteCard } from '../onboard-section/onboard-steps/onboarding-complete/onboarding-complete';

export const GettingStartedPopup = () => {
  const { isPopupGuideOpen, closePopupGuide, isOnboardingComplete, onboardingSteps } = useHomePageOnboardContext();

  const shouldShowTrialWarningBanner = useShouldShowTrialWarningBanner();
  const shouldShowTrialInfoBanner = useShouldShowTrialInfoBanner();

  if (!isPopupGuideOpen) {
    return null;
  }

  const isBannerDisplayed = shouldShowTrialWarningBanner || shouldShowTrialInfoBanner;

  if (isOnboardingComplete) {
    return (
      <div
        className={classnames(style.popup, {
          [style['banner-is-visible']]: isBannerDisplayed,
        })}
      >
        <FlexRow className={style['popup-header']}>
          <Text textType={TextType.H3} value={messages.onboardingCompleteHeading} />
          <IconButton
            ariaLabelMessageDescriptor={messages.gettingStarted}
            className={style['close-button']}
            icon={faXmark}
            onClick={closePopupGuide}
          />
        </FlexRow>
        <div className={style['popup-body']}>
          <OnboardingCompleteCard />
        </div>
      </div>
    );
  }

  return (
    <div
      className={classnames(style.popup, {
        [style['banner-is-visible']]: isBannerDisplayed,
      })}
    >
      <FlexRow className={style['popup-header']}>
        <Text textType={TextType.H3} value={messages.gettingStarted} />
        <IconButton
          ariaLabelMessageDescriptor={messages.gettingStarted}
          className={style['close-button']}
          icon={faXmark}
          onClick={closePopupGuide}
        />
      </FlexRow>
      <div className={style['popup-body']}>
        {onboardingSteps.map((step) => {
          const Step = OnboardingStepsComponents[step];
          return (
            <div key={step} className={style['popup-section']}>
              <Step key={step} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
